import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from "polotno";
import { Toolbar } from "polotno/toolbar/toolbar";
import { ZoomButtons } from "polotno/toolbar/zoom-buttons";
import { SidePanel, DEFAULT_SECTIONS } from "polotno/side-panel";
import { Workspace } from "polotno/canvas/workspace";
import { Tooltip } from "polotno/canvas/tooltip";
import { setTranslations } from "polotno/config";
import Topbar from "./topbar/topbar";
import { loginUser, language, loginModal } from "./Redux/authAction";
import { loadFile } from "./file";
import { useProject } from "./project";
import { ImageRemoveBackground } from "./background-remover";
import { TemplatesSection } from "./templates-panel";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
// Import translations
import fr from "./translations/fr";
import en from "./translations/en";
import id from "./translations/id";
import ru from "./translations/ru";
import ptBr from "./translations/pt-br";

// Import other sections
import { ShapesSection } from "./sections/shapes-section";
import { IconsSection } from "./sections/icons-section";
import { QuotesSection } from "./sections/quotes-section";
import { QrSection } from "./sections/qr-section";
import { StableDiffusionSection } from "./sections/stable-diffusion-section";

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; 

import api from './config/api';

// Update default sections
DEFAULT_SECTIONS.splice(3, 1, ShapesSection);
DEFAULT_SECTIONS.splice(3, 0, IconsSection);
DEFAULT_SECTIONS.push(QuotesSection, QrSection);
DEFAULT_SECTIONS.unshift(TemplatesSection);
DEFAULT_SECTIONS.push(StableDiffusionSection);

const useHeight = () => {
  const [height, setHeight] = React.useState(window.innerHeight);
  React.useEffect(() => {
    window.addEventListener("resize", () => {
      setHeight(window.innerHeight);
    });
  }, []);
  return height;
};

const Polotno = observer(() => {
  const dispatch = useDispatch(); // Added dispatch here

  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault(); // Prevent the default right-click menu
    };

    document.addEventListener("contextmenu", handleContextMenu);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  const displayName = useSelector((state) => state.authReducer.displayName); // Moved outside
  const email = useSelector((state) => state.authReducer.email); // Moved outside
  const uid = useSelector((state) => state.authReducer.uid); // Moved outside
  const packageid = useSelector((state) => state.authReducer.packageid); // Moved outside
  const status = useSelector((state) => state.authReducer.status); // Moved outside
  const prevtemp_pkgid = useSelector((state) => state.authReducer.temp_pkgid); // Moved outside
  const templatepackageid = useSelector((state) => state.authReducer.temp_pkgid); // Moved outside
  console.log("Template Package isss.................", templatepackageid);
  const project = useProject();
  const height = useHeight();
  const [templateData, setTemplateData] = useState(null);
  const { text: str } = useParams();
  const { category: paramCategory } = useParams();
  const userID = useSelector((state) => state.authReducer.uid);

  const [category, setCategory] = useState(paramCategory || "all");
  console.log("value --------", userID);
  const navigate = useNavigate();

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );

  useEffect(() => {
    const handleReload = () => {
      // Check if the page is being reloaded
      if (performance.navigation.type === 1) {
        // Show an alert
        navigate("/");
      }
    };

    // Add event listener for page load
    window.addEventListener("load", handleReload);

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("load", handleReload);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const formDataToSend = new FormData();
        let response; // Define response variable

        if (str === "save") {
          // Make API call for save
          formDataToSend.append("id", category);
          response = await fetch(
            api.getUrl(api.ENDPOINTS.GET_USER_TEMPLATE_BY_ID),
            {
              method: "POST",
              body: formDataToSend,
            }
          );
        } else {
          // Make API call for other cases
          formDataToSend.append("id", category);
          console.log("id of template: ", category);
          response = await fetch(api.getUrl(api.ENDPOINTS.GET_TEMPLATE_BY_ID), {
            method: "POST",
            body: formDataToSend,
          });
        }

        if (response.ok) {
          const result = await response.json();
          console.log("Template Package isss.................", templatepackageid);
          console.log("result the package------------>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>))))))))))))))))))))-----------   :", result[0].pkgid);
          const temp_pkgid = result[0].pkgid;
          const temp_id = result[0].id;
          console.log(displayName, uid, packageid, status, temp_pkgid, "templateid:", temp_id);
          if (uid !== null) {
            dispatch(loginUser({ displayName, uid, email, packageid, status, temp_pkgid, temp_id }));
          }
          // Fix: Using 'email' here
          console.log("temp package id: ", temp_pkgid);

          console.log("clicked template: ", prevtemp_pkgid);
          setTemplateData(result[0]);
          // Check templetepath based on str value
          let jsonFileUrl;
          if (str === "save") {
            jsonFileUrl = `${api.API_URL}/aapi/userTempletes/${result[0].templetepath}`;
          } else {
            jsonFileUrl = `${api.API_URL}/aapi/templetes/${result[0].templetepath}`;
          }
          // Load JSON file into Polotno
          const jsonFileResponse = await fetch(jsonFileUrl);
          const jsonFileText = await jsonFileResponse.text();
          const jsonFile = JSON.parse(jsonFileText);
          console.log("Json text file is: ", jsonFileText);
          await project.createNewDesign();
          store.loadJSON(jsonFile);
          project.save();
        } else {
          console.error("API request failed");
        }
      } catch (error) {
        console.error("Error during API request:", error);
      }
    };

    if (!isNaN(paramCategory)) {
      fetchData();
    } else {
      console.log("string");
    }
  }, [str, category, paramCategory, project, store, dispatch]); // Added dispatch to dependency array

  useEffect(() => {
    if (project.language.startsWith("fr")) {
      setTranslations(fr);
    } else if (project.language.startsWith("id")) {
      setTranslations(id);
    } else if (project.language.startsWith("ru")) {
      setTranslations(ru);
    } else if (project.language.startsWith("pt")) {
      setTranslations(ptBr);
    } else {
      setTranslations(en);
    }
  }, [project.language]);

  const handleDrop = (ev) => {
    ev.preventDefault();

    if (ev.dataTransfer.files.length !== ev.dataTransfer.items.length) {
      return;
    }
    for (let i = 0; i < ev.dataTransfer.files.length; i++) {
      loadFile(ev.dataTransfer.files[i], store);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: height + "px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
      onDrop={handleDrop}
    >
      <Topbar store={store} />

      <div style={{ height: "calc(100% - 50px)" }}>
        <PolotnoContainer className="polotno-app-container">
          <SidePanelWrap>
            <SidePanel
              store={store}
              sections={DEFAULT_SECTIONS}
              defaultSection="custom-templates"
            />
          </SidePanelWrap>
          <WorkspaceWrap>
            <Toolbar
              store={store}
              // components={{
              //   ImageRemoveBackground,
              // }}
            />
            <div
              style={{
                width: "200px",
                height: "50px",
                background: "rgb(232,232,232)",
                position: "absolute",
                zIndex: 999,
                right: 0,
                bottom: 0,
              }}
            ></div>
            <Workspace store={store} components={{ Tooltip }} />
            <ZoomButtons store={store} />
          </WorkspaceWrap>
        </PolotnoContainer>
      </div>
    </div>
  );
});

export default Polotno;
